<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalStockOpnameDetail v-if="modalShowStockOpnameDetail" @closeModal="closeModal"
    :stockOpnameDetail="selectedStockOpnameDetail" :parentItemId="$route.params?.id" />
  <ModalChooseProduct v-if="modalShowChooseProduct" @closeModal="closeModalProduct" @submit="submitProduct" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
  <section class="p-6">
    <BackButton class="mb-5" to_url="/stock-opname" />
    <PageTitle title="Edit Stok Opname" />
    <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500">
      <InputRadio v-model="stockOpname.form_type" id="form-type" name="form-type" label="Tipe Stok Opname"
        :options="[{ value: 'common', label: 'Stock Opname' }, { value: 'misc', label: 'Lain-lain' }]"
        :valid="validation.form_type.valid" :error-message="validation.form_type.message" />
      <div id="table-header" class="mb-5 mt-5 flex justify-between">
        <AddButton v-if="stockOpname.status != 'paid'" to_url="#" button_text="Pilih Item" button_class="text-base py-2 font-medium"
          @click="showModalProduct" />
      </div>

      <div class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <TableComponent>
              <TableHead>
                <TableRow>
                  <TableHeadCell>No</TableHeadCell>
                  <TableHeadCell>Action</TableHeadCell>
                  <TableHeadCell>Status</TableHeadCell>
                  <TableHeadCell>Kode Item</TableHeadCell>
                  <TableHeadCell>Nama Item</TableHeadCell>
                  <TableHeadCell>Stok Saat Ini</TableHeadCell>
                  <TableHeadCell>Qty</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow v-if="stockOpnameDetails?.length == 0">
                  <TableCell colspan="7" customClass="text-center italic text-gray-400 dark:text-gray-500" noTextColor>
                    Belum ada data
                  </TableCell>
                </TableRow>
                <TableRow v-else v-for="(stockOpnameDetail, index) in stockOpnameDetails" :key="stockOpnameDetail.id"
                  :index="index" isBody>
                  <TableCell>{{ index + 1 }}</TableCell>
                  <TableCell>
                    <div class="justify-center items-center text-gray-500 dark:text-gray-400 flex" v-if="stockOpname.status != 'paid'">
                      <button v-if="stockOpnameDetail.isEdit" :id="'edit-data-' + stockOpnameDetail.id"
                        @click="submitStockOpnameDetail(stockOpnameDetail)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <ArrowDownTrayIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'delete-data-' + stockOpnameDetail.id"
                        @click="deleteStockOpnameDetail(stockOpnameDetail)"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button>
                    </div>
                  </TableCell>
                  <TableCell>
                    <span :class="{
                        'bg-red-500 dark:bg-red-500 text-light-50 dark:text-white': stockOpnameDetail.isEdit,
                        'bg-green-500 dark:bg-green-500 text-white dark:text-white': !stockOpnameDetail.isEdit
                      }" class="px-2 py-1 rounded-full text-sm font-medium">
                      {{ stockOpnameDetail.isEdit ? 'Belum Disimpan' : 'Tersimpan' }}
                    </span>
                  </TableCell>
                  <TableCell>{{ stockOpnameDetail.items?.code }}</TableCell>
                  <TableCell>{{ stockOpnameDetail.items?.name }}</TableCell>
                  <TableCell>{{ allItems.find(item => item.id == stockOpnameDetail.item_id)?.stockMovements?.[0]?.closing_balance }}</TableCell>
                  <TableCell>
                    <div v-if="stockOpname.status != 'paid'" class="flex items-center rounded-lg p-1">
                      <button @click="reduceItem(stockOpnameDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                        <MinusCircleIcon class="h-5 w-5" />
                      </button>
                      <InputTextCustom v-model="stockOpnameDetail.qty" id="item-min-qty-per-unit" type="number" div_class="w-20" min="0" @input="inputQty(stockOpnameDetail)"/>
                      <button @click="addItem(stockOpnameDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                        <PlusCircleIcon class="h-5 w-5" />
                        </button>
                    </div>
                    <div v-else>
                      {{ stockOpnameDetail.qty }}
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableComponent>
          </div>
        </div>
      </div>

      <div class="mt-3 flex justify-center gap-3" v-if="stockOpname.status != 'paid'">
        <Button type="submit" label="Simpan" :loading="loading" @click="submitStockOpname" />
        <Button type="submit" label="Posting" :loading="loading" @click="submitCloseStockOpname" />
      </div>
      <div class="flex justify-center" v-if="stockOpname.status == 'paid'">
        Sudah Diposting
      </div>
    </div>
  </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputRadio from '@/components/form/InputRadio.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import AddButton from "@/components/buttons/AddButton.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import ModalStockOpnameDetail from '@/components/modals/ModalStockOpnameDetail.vue';
import { TrashIcon } from "@heroicons/vue/24/solid";
import ModalChooseProduct from '@/components/modals/ModalChooseProduct.vue';
import ViewContainer from '@/components/ViewContainer.vue';
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import { PlusCircleIcon, MinusCircleIcon, ArrowDownTrayIcon } from "@heroicons/vue/24/solid";

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, InputRadio, Button, ConfirmDialog, Toast,
    AddButton, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell,
    ModalStockOpnameDetail, TrashIcon, ModalChooseProduct, ViewContainer, InputTextCustom, PlusCircleIcon, MinusCircleIcon, ArrowDownTrayIcon
  },
  data() {
    return {
      loading: false,
      stockOpname: {
        form_type: null,
      },
      stockOpnameDetails: [],
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
      },
      validationDetail: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      modalShowStockOpnameDetail: false,
      isBlur: false,
      selectedStockOpnameDetail: null,
      modalShowChooseProduct: false,
    }
  },
  computed: {
    ...mapGetters('items', ['allItems']),
  },
  async created() {
    this.fetchStockOpname();
    this.fetchStockOpnameDetails();
    this.$store.dispatch('items/fetchItems');
  },
  methods: {
    ...mapActions('stock_opnames', ['updateStockOpname', 'closeStockOpname']),
    ...mapActions('stock_opname_details', ['deleteStockOpnameDetailById', 'createStockOpnameDetail', 'updateStockOpnameDetail']),
    async fetchStockOpname() {
      const response = await this.$store.dispatch('stock_opnames/fetchStockOpnameById', this.$route.params.id);
      this.stockOpname = response.data;
    },
    async fetchStockOpnameDetails() {
      const response = await this.$store.dispatch('stock_opname_details/fetchStockOpnameDetails', { stock_opname_id: this.$route.params.id, limit: 1000 });
      if (response) {
        this.stockOpnameDetails = response.data;
      } else {
        this.stockOpnameDetails = [];
      }
    },
    addItem(item) {
      const existingItemIndex = this.stockOpnameDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.stockOpnameDetails[existingItemIndex].qty = Number(this.stockOpnameDetails[existingItemIndex].qty) + 1;
        this.stockOpnameDetails[existingItemIndex].isEdit = true;
      }
    },
    reduceItem(item) {
      const existingItemIndex = this.stockOpnameDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.stockOpnameDetails[existingItemIndex].qty = Number(this.stockOpnameDetails[existingItemIndex].qty) > 1 ? Number(this.stockOpnameDetails[existingItemIndex].qty) - 1 : 0;
        this.stockOpnameDetails[existingItemIndex].isEdit = true;
      }
    },
    inputQty(item) {
      item.isEdit = true;
      item.qty = Number(item.qty) <= 0 ? 0 : item.qty;
    },
    submitStockOpname() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft stok opname?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postStockOpname();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft stok opname', life: 3000 });
        }
      });
    },
    async postStockOpname() {
      try {
        this.loading = true;
        const stockOpnameData = {
          form_type: this.formType,
          id: this.$route.params.id,
        };

        for await (const detail of this.stockOpnameDetails) {
          await this.updateStockOpnameDetail(detail);
        }

        await this.updateStockOpname(stockOpnameData);
        await this.fetchStockOpname();

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save stock opname:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    submitCloseStockOpname() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin posting stok opname?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postCloseStockOpname();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan posting stok opname', life: 3000 });
        }
      });
    },
    async postCloseStockOpname() {
      try {
        this.loading = true;
        const stockOpnameData = {
          transaction_id: this.$route.params.id,
        };

        for await (const detail of this.stockOpnameDetails) {
          await this.updateStockOpnameDetail(detail);
        }

        await this.closeStockOpname(stockOpnameData);
        await this.fetchStockOpname();

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save stock opname:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },

    editStockOpnameDetail(stockOpnameDetail) {
      this.selectedStockOpnameDetail = stockOpnameDetail;
      this.modalShowStockOpnameDetail = true;
      this.isBlur = true;
    },
    async deleteStockOpnameDetail(table) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus detail?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.deleteStockOpnameDetailById(table.id);
            this.fetchStockOpnameDetails();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus detail', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus detail', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus detail', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus detail', life: 3000 });
        }
      });
    },

    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },

    showModal() {
      this.modalShowStockOpnameDetail = true;
      this.isBlur = true;
      this.selectedStockOpnameDetail = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowStockOpnameDetail = false;
        this.isBlur = false;
        this.fetchStockOpnameDetails();
      }, 200);
    },
    showModalProduct() {
      this.modalShowChooseProduct = true;
      this.isBlur = true;
    },
    closeModalProduct() {
      setTimeout(() => {
        this.modalShowChooseProduct = false;
        this.isBlur = false;
      }, 200);
    },
    async submitProduct(items) {
      try {
        for await (const item of items) {
          const stockOpnameDetailData = {
            stock_opname_id: this.$route.params.id,
            item_id: item.id,
          };

          const existingItem = this.stockOpnameDetails.find(detail => detail.item_id === item.id);

          if (existingItem) {
            stockOpnameDetailData.id = existingItem.id;
            await this.updateStockOpnameDetail(stockOpnameDetailData);
          }
          else {
            stockOpnameDetailData.qty = 0;
            await this.createStockOpnameDetail(stockOpnameDetailData);
          }
        }

        this.closeModalProduct();
        this.fetchStockOpnameDetails();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    submitStockOpnameDetail(item) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postStockOpnameDetail(item);
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
    async postStockOpnameDetail(item) {
      try {
        const stockOpnameDetailData = {
          stock_opname_id: this.$route.params.id,
          item_id: item.item_id,
          qty: item.qty,
          note: item.note,
        };

        if (item.id) {
          stockOpnameDetailData.id = item.id;
          await this.updateStockOpnameDetail(stockOpnameDetailData);
        }

        // Update the item in the array and set isEdit to false
        this.stockOpnameDetails = this.stockOpnameDetails.map(detail => {
          if (detail.id === item.id) {
            return { ...item, isEdit: false };
          }
          return detail;
        });
        
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrorsDetail(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrorsDetail(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validationDetail[this.field[index]].valid = true;
        this.validationDetail[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validationDetail[error.field]) {
          this.validationDetail[error.field].valid = false;
          this.validationDetail[error.field].message = error.message;
        }
      });
    }
  },
}
</script>